import React from 'react';

type CurrencyContextData = {
  currency: Currency;
};

export const CurrencyContext = React.createContext<CurrencyContextData>({
  currency: 'EUR',
});
